import { z } from 'zod';
import { DateFromIsoString } from '~/root/domain';

const UserAvatarInfo = z.object({
  id: z.number().nullable(),
  name: z.string().nullable(),
  avatar_link: z.string().nullable(),
});

const EmailParticipant = z.object({
  email: z.string(),
});

const RequestBase = z.object({
  id: z.number(),
  status: z.string(),
  actor: UserAvatarInfo,
  last_resend_at: DateFromIsoString.nullable(),
});

export const requestSchema = z.discriminatedUnion('type', [
  RequestBase.extend({
    type: z.literal('transfer-ownership'),
    from: UserAvatarInfo,
    to: UserAvatarInfo,
  }),
  RequestBase.extend({
    type: z.literal('email-change'),
    source: z.enum(['inner_platform', 'customer_area']),
    from: EmailParticipant,
    to: EmailParticipant,
    expires_at: DateFromIsoString,
  }),
]);

export type Request = z.infer<typeof requestSchema>;
export type EmailChangeRequest = Extract<Request, { type: 'email-change' }>;
